import { PERMISSIONS } from './permissionConstants';

/**
 * Single source of truth for admin sidebar items and route permission checks.
 * Categorized matching the Andy Admin Navigation structure.
 * Pin-to-pin aligned with src/SuperAdmin/permissions.json.
 */
export const ADMIN_NAV_ITEMS = [
  {
    label: 'Dashboard',
    to: '/admin/dashboard',
    permissions: [PERMISSIONS.DASHBOARD, PERMISSIONS.DASHBOARD_VIEW],
  },
  {
    label: 'Dashboard',
    to: '/admin/sales-dashboard',
    permissions: [PERMISSIONS.SALES_DASHBOARD_VIEW, PERMISSIONS.SALES_DASHBOARD],
  },
  {
    label: 'Roles & Permissions',
    to: '/super-admin-roles',
    permissions: [
      PERMISSIONS.ROLES_PERMISSIONS,
      PERMISSIONS.ROLES_VIEW,
      PERMISSIONS.ROLES_CREATE,
      PERMISSIONS.ROLES_UPDATE,
      PERMISSIONS.ROLES_DELETE,
      PERMISSIONS.ROLES_ASSIGN_PERMISSIONS,
    ],
  },
  {
    label: 'User & Team Management',
    permissions: [
      PERMISSIONS.CLIENTS,
      PERMISSIONS.CLIENTS_VIEW,
      PERMISSIONS.AFFILIATES,
      PERMISSIONS.AFFILIATES_VIEW,
      PERMISSIONS.PARTNERS,
      PERMISSIONS.PARTNERS_VIEW,
      // PERMISSIONS.ROLES_PERMISSIONS,
      // PERMISSIONS.ROLES_VIEW,
      // PERMISSIONS.ROLES_CREATE,
      // PERMISSIONS.ROLES_UPDATE,
      // PERMISSIONS.ROLES_DELETE,
      // PERMISSIONS.ROLES_ASSIGN_PERMISSIONS,
    ],
    children: [
      {
        label: 'Clients',
        to: '/users',
        permissions: [PERMISSIONS.CLIENTS, PERMISSIONS.CLIENTS_VIEW],
      },
      {
        label: 'Team Andy',
        to: '/recruiters',
        permissions: [PERMISSIONS.AFFILIATES, PERMISSIONS.AFFILIATES_VIEW],
      },
      {
        label: 'Partners',
        to: '/admin/partners',
        permissions: [PERMISSIONS.PARTNERS, PERMISSIONS.PARTNERS_VIEW],
      },
      {
        label: 'Roles & Permissions',
        to: '/super-admin-roles',
        permissions: [
          PERMISSIONS.ROLES_PERMISSIONS,
          PERMISSIONS.ROLES_VIEW,
          PERMISSIONS.ROLES_CREATE,
          PERMISSIONS.ROLES_UPDATE,
          PERMISSIONS.ROLES_DELETE,
          PERMISSIONS.ROLES_ASSIGN_PERMISSIONS,
        ],
      },
    ],
  },
  {
    label: 'Property & Tax Management',
    permissions: [
      PERMISSIONS.PROPERTY_PROVISIONING,
      PERMISSIONS.PROPERTY_REPORT,
      PERMISSIONS.PROPERTY_REPORT_VIEW,
      PERMISSIONS.HOMESTEAD,
      PERMISSIONS.PROTESTS_EXEMPTIONS,
      PERMISSIONS.PROTESTS_VIEW_DETAILS,
      PERMISSIONS.EXEMPTIONS_VIEW_DETAILS,
      PERMISSIONS.ESTIMATE_REQUEST,
      PERMISSIONS.ESTIMATE_REQUEST_VIEW,
    ],
    children: [
      {
        label: 'Properties',
        to: '/admin/properties',
        permissions: [PERMISSIONS.PROPERTY_PROVISIONING],
      },
      {
        label: 'Property Report',
        to: '/admin/property-report',
        permissions: [PERMISSIONS.PROPERTY_REPORT, PERMISSIONS.PROPERTY_REPORT_VIEW],
      },
      {
        label: 'Homestead',
        to: '/admin/homestead',
        permissions: [PERMISSIONS.HOMESTEAD],
      },
      {
        label: 'Protests & Exemptions',
        to: '/admin-protest',
        permissions: [
          PERMISSIONS.PROTESTS_EXEMPTIONS,
          PERMISSIONS.PROTESTS_VIEW_DETAILS,
          PERMISSIONS.EXEMPTIONS_VIEW_DETAILS,
        ],
      },
      {
        label: 'Estimate Requests',
        to: '/admin/estimate-requests',
        permissions: [
          PERMISSIONS.ESTIMATE_REQUEST,
          PERMISSIONS.ESTIMATE_REQUEST_VIEW,
        ],
      },
    ],
  },
  {
    label: 'Referral Management',
    permissions: [
      PERMISSIONS.REFERRALS,
      PERMISSIONS.REFERRALS_VIEW,
      PERMISSIONS.REFERRAL_REQUESTS,
      PERMISSIONS.REFERRAL_REQUESTS_VIEW,
      PERMISSIONS.CLIENTS_REFERRAL_REQUESTS_VIEW,
      PERMISSIONS.REFERRAL_REQUESTS_VIEW_DETAILS,
      PERMISSIONS.REFERRALS_CODES,
    ],
    children: [
      {
        label: 'Referrals',
        to: '/referral',
        permissions: [PERMISSIONS.REFERRALS, PERMISSIONS.REFERRALS_VIEW],
      },
      {
        label: 'Referral Requests',
        to: '/referral-request',
        permissions: [
          PERMISSIONS.REFERRAL_REQUESTS,
          PERMISSIONS.REFERRAL_REQUESTS_VIEW,
          PERMISSIONS.CLIENTS_REFERRAL_REQUESTS_VIEW,
          PERMISSIONS.REFERRAL_REQUESTS_VIEW_DETAILS,
        ],
      },
      {
        label: 'Referral Codes',
        to: '/admin/referral-codes',
        permissions: [PERMISSIONS.REFERRALS_CODES],
      },
    ],
  },
  {
    label: 'Training & Resources',
    permissions: [
      PERMISSIONS.TRAINING_LIBRARY,
      PERMISSIONS.TRAINING_VIEW,
      PERMISSIONS.TRAINING_ALL,
      PERMISSIONS.TRAINING,
    ],
    children: [
      {
        label: 'Training Library',
        to: '/training-library',
        permissions: [
          PERMISSIONS.TRAINING_LIBRARY,
          PERMISSIONS.TRAINING_VIEW,
          PERMISSIONS.TRAINING_ALL,
          PERMISSIONS.TRAINING,
        ],
      },
    ],
  },
  {
    label: 'Finance & Payments',
    permissions: [
      PERMISSIONS.PAYOUTS,
      PERMISSIONS.PAYOUTS_VIEW,
      PERMISSIONS.REFUND_INVOICES_VIEW,
    ],
    children: [
      {
        label: 'Payouts',
        to: '/withdraw-request',
        permissions: [PERMISSIONS.PAYOUTS, PERMISSIONS.PAYOUTS_VIEW],
      },
      {
        label: 'Refund Invoices',
        to: '/admin/refund-invoices',
        permissions: [PERMISSIONS.REFUND_INVOICES_VIEW],
      },
    ],
  },
  {
    label: 'Marketing & Engagement',
    permissions: [
      PERMISSIONS.CAMPAIGN,
      PERMISSIONS.CAMPAIGN_VIEW,
      PERMISSIONS.CAMPAIGN_LEADS,
      PERMISSIONS.CAMPAIGN_LEADS_VIEW,
      PERMISSIONS.COUPONS,
      PERMISSIONS.COUPONS_VIEW,
      PERMISSIONS.PUSH_NOTIFICATIONS,
      PERMISSIONS.NOTIFICATIONS_VIEW,
      PERMISSIONS.NOTIFICATIONS_VIEW_DETAILS,
    ],
    children: [
      {
        label: 'Campaign',
        to: '/campaign',
        permissions: [PERMISSIONS.CAMPAIGN, PERMISSIONS.CAMPAIGN_VIEW],
      },
      {
        label: 'Campaign Lead Step',
        to: '/campaign-leadstep',
        permissions: [PERMISSIONS.CAMPAIGN_LEADS, PERMISSIONS.CAMPAIGN_LEADS_VIEW],
      },
      {
        label: 'Coupons',
        to: '/admin-coupons',
        permissions: [
          PERMISSIONS.COUPONS,
          PERMISSIONS.COUPONS_VIEW,
        ],
      },
      {
        label: 'Push Notifications',
        to: '/push-notification',
        permissions: [
          PERMISSIONS.PUSH_NOTIFICATIONS,
          PERMISSIONS.NOTIFICATIONS_VIEW,
          PERMISSIONS.NOTIFICATIONS_VIEW_DETAILS,
        ],
      },
    ],
  },
  {
    label: 'Content Management',
    permissions: [
      PERMISSIONS.CMS_BLOGS,
      PERMISSIONS.CMS_BLOGS_VIEW,
      PERMISSIONS.CMS_NEWS,
      PERMISSIONS.CMS_NEWS_VIEW,
      PERMISSIONS.CMS_AUTHORS,
      PERMISSIONS.CMS_AUTHORS_VIEW,
      PERMISSIONS.CMS_TAXONOMY,
      PERMISSIONS.CMS_TAXONOMY_VIEW,
      PERMISSIONS.CMS_TAXONOMY_MANAGE,
      PERMISSIONS.CMS_MEDIA,
      PERMISSIONS.CMS_MEDIA_VIEW,
      PERMISSIONS.CMS_SUBSCRIBERS,
      PERMISSIONS.CMS_SUBSCRIBERS_VIEW,
      PERMISSIONS.CMS_FAQS,
      PERMISSIONS.CMS_FAQS_VIEW,
      PERMISSIONS.CMS_MANAGE,
    ],
    children: [
      {
        label: 'Blogs',
        to: '/admin/blogs',
        permissions: [
          PERMISSIONS.CMS_BLOGS,
          PERMISSIONS.CMS_BLOGS_VIEW,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
      {
        label: 'News & Updates',
        to: '/admin/news',
        permissions: [
          PERMISSIONS.CMS_NEWS,
          PERMISSIONS.CMS_NEWS_VIEW,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
      {
        label: 'Authors',
        to: '/admin/authors',
        permissions: [
          PERMISSIONS.CMS_AUTHORS,
          PERMISSIONS.CMS_AUTHORS_VIEW,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
      {
        label: 'Categories',
        to: '/admin/categories',
        permissions: [
          PERMISSIONS.CMS_TAXONOMY,
          PERMISSIONS.CMS_TAXONOMY_VIEW,
          PERMISSIONS.CMS_TAXONOMY_MANAGE,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
      {
        label: 'Tags',
        to: '/admin/tags',
        permissions: [
          PERMISSIONS.CMS_TAXONOMY,
          PERMISSIONS.CMS_TAXONOMY_VIEW,
          PERMISSIONS.CMS_TAXONOMY_MANAGE,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
      {
        label: 'Media Library',
        to: '/admin/media-library',
        permissions: [
          PERMISSIONS.CMS_MEDIA,
          PERMISSIONS.CMS_MEDIA_VIEW,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
      {
        label: 'Subscribers',
        to: '/admin/subscribers',
        permissions: [
          PERMISSIONS.CMS_SUBSCRIBERS,
          PERMISSIONS.CMS_SUBSCRIBERS_VIEW,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
      {
        label: 'FAQs',
        to: '/admin/faqs',
        permissions: [
          PERMISSIONS.CMS_FAQS,
          PERMISSIONS.CMS_FAQS_VIEW,
          PERMISSIONS.CMS_MANAGE,
        ],
      },
    ],
  },
  {
    label: 'Support',
    permissions: [
      PERMISSIONS.CLIENT_INBOX,
      PERMISSIONS.CLIENT_INBOX_VIEW,
      PERMISSIONS.AFFILIATE_INBOX,
      PERMISSIONS.AFFILIATE_INBOX_VIEW,
    ],
    children: [
      {
        label: 'Client Inbox',
        to: '/admin-chat',
        permissions: [PERMISSIONS.CLIENT_INBOX, PERMISSIONS.CLIENT_INBOX_VIEW],
      },
      {
        label: 'Recruiter Inbox',
        to: '/affiliate-chat',
        permissions: [
          PERMISSIONS.AFFILIATE_INBOX,
          PERMISSIONS.AFFILIATE_INBOX_VIEW,
        ],
      },
    ],
  },
  {
    label: 'Reports & Analytics',
    permissions: [PERMISSIONS.ANALYTICS, PERMISSIONS.ANALYTICS_VIEW],
    children: [
      {
        label: 'Analytics',
        to: '/admin-analytics',
        permissions: [PERMISSIONS.ANALYTICS, PERMISSIONS.ANALYTICS_VIEW],
      },
    ],
  },
  {
    label: 'System Management',
    permissions: [
      PERMISSIONS.APP_VERSION,
      PERMISSIONS.APP_VERSION_VIEW,
    ],
    children: [
      {
        label: 'App Version Control',
        to: '/versions',
        permissions: [
          PERMISSIONS.APP_VERSION,
          PERMISSIONS.APP_VERSION_VIEW,
        ],
      },
    ],
  },
];

/** Routes not listed in sidebar but still permission-guarded */
export const ADMIN_EXTRA_ROUTE_PERMISSIONS = {
  '/admin/sales-dashboard': [
    PERMISSIONS.SALES_DASHBOARD,
    PERMISSIONS.SALES_DASHBOARD_VIEW,
  ],
  '/super-admin-roles': [
    PERMISSIONS.ROLES_VIEW,
    PERMISSIONS.ROLES_PERMISSIONS,
    PERMISSIONS.ROLES_CREATE,
    PERMISSIONS.ROLES_UPDATE,
    PERMISSIONS.ROLES_DELETE,
    PERMISSIONS.ROLES_ASSIGN_PERMISSIONS,
  ],
  '/admin/recruiter-meetings': [
    PERMISSIONS.RECRUITER_MEETINGS,
    PERMISSIONS.RECRUITER_MEETINGS_VIEW,
  ],
  '/admin-grafana': [PERMISSIONS.GRAFANA],
  '/admin-grafana/server': [PERMISSIONS.GRAFANA],
  '/admin-grafana/containers': [PERMISSIONS.GRAFANA],
  '/admin/blogs/new': [PERMISSIONS.CMS_BLOGS_CREATE, PERMISSIONS.CMS_BLOGS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/news/new': [PERMISSIONS.CMS_NEWS_CREATE, PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/updates/new': [PERMISSIONS.CMS_NEWS_CREATE, PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/authors/new': [PERMISSIONS.CMS_AUTHORS_CREATE, PERMISSIONS.CMS_AUTHORS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/blogs/edit': [PERMISSIONS.CMS_BLOGS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/news/edit': [PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/updates/edit': [PERMISSIONS.CMS_NEWS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/authors/edit': [PERMISSIONS.CMS_AUTHORS_UPDATE, PERMISSIONS.CMS_MANAGE],
  '/admin/estimate-requests/new': [
    PERMISSIONS.ESTIMATE_REQUEST,
    PERMISSIONS.ESTIMATE_REQUEST_VIEW,
    PERMISSIONS.ESTIMATE_REQUEST_ADD,
  ],
  '/sales/estimate-requests': [
    PERMISSIONS.ESTIMATE_REQUEST,
    PERMISSIONS.ESTIMATE_REQUEST_VIEW,
    PERMISSIONS.ESTIMATE_REQUEST_ADD,
  ],
  '/sales/estimate-requests/new': [
    PERMISSIONS.ESTIMATE_REQUEST,
    PERMISSIONS.ESTIMATE_REQUEST_VIEW,
    PERMISSIONS.ESTIMATE_REQUEST_ADD,
  ],
  '/sales/sales-dashboard': [
    PERMISSIONS.SALES_DASHBOARD,
    PERMISSIONS.SALES_DASHBOARD_VIEW,
  ],
  '/sales/dashboard': [
    PERMISSIONS.SALES_DASHBOARD,
    PERMISSIONS.SALES_DASHBOARD_VIEW,
  ],
  '/sales-dashboard': [
    PERMISSIONS.SALES_DASHBOARD,
    PERMISSIONS.SALES_DASHBOARD_VIEW,
  ],
  '/admin/notifications': [
    PERMISSIONS.PUSH_NOTIFICATIONS,
    PERMISSIONS.NOTIFICATIONS_VIEW,
    PERMISSIONS.NOTIFICATIONS_CREATE,
  ],
  '/reports': [PERMISSIONS.ANALYTICS, PERMISSIONS.ANALYTICS_VIEW],
  '/admin-badges': [PERMISSIONS.ANALYTICS, PERMISSIONS.ANALYTICS_VIEW],
  '/activation': [PERMISSIONS.CAMPAIGN, PERMISSIONS.CAMPAIGN_VIEW],
};

const flattenNavRoutes = (items) => {
  const routes = [];
  items.forEach((item) => {
    if (item.to) routes.push(item);
    if (item.children?.length) routes.push(...flattenNavRoutes(item.children));
  });
  return routes;
};

export const getPermissionsForRoute = (path) => {
  const navItem = flattenNavRoutes(ADMIN_NAV_ITEMS).find((item) => item.to === path);
  if (navItem) return navItem.permissions;
  return ADMIN_EXTRA_ROUTE_PERMISSIONS[path] || [];
};

export const buildRoutePermissionsMap = () => {
  const map = { ...ADMIN_EXTRA_ROUTE_PERMISSIONS };
  flattenNavRoutes(ADMIN_NAV_ITEMS).forEach((item) => {
    map[item.to] = item.permissions;
  });
  return map;
};

const matchAnyPermission = (userPermissions, requiredPermissions) => {
  const safe = Array.isArray(userPermissions) ? userPermissions : [];
  if (!requiredPermissions?.length) return false;
  return requiredPermissions.some((p) => safe.includes(p));
};

export const ROUTE_PERMISSIONS = buildRoutePermissionsMap();

export const getRoutePermissions = (route) => {
  if (route) {
    if (route.startsWith('/admin/blogs/edit/')) return ROUTE_PERMISSIONS['/admin/blogs/edit'] || [];
    if (route.startsWith('/admin/news/edit/')) return ROUTE_PERMISSIONS['/admin/news/edit'] || [];
    if (route.startsWith('/admin/updates/edit/')) return ROUTE_PERMISSIONS['/admin/updates/edit'] || [];
    if (route.startsWith('/admin/authors/edit/')) return ROUTE_PERMISSIONS['/admin/authors/edit'] || [];
  }
  return ROUTE_PERMISSIONS[route] || [];
};

export const getDefaultAdminPath = (userPermissions) => {
  for (const item of ADMIN_NAV_ITEMS) {
    if (item.to && matchAnyPermission(userPermissions, item.permissions)) {
      return item.to;
    }
    if (item.children?.length) {
      const firstChild = item.children.find((child) =>
        matchAnyPermission(userPermissions, child.permissions)
      );
      if (firstChild?.to) return firstChild.to;
    }
    if (!matchAnyPermission(userPermissions, item.permissions)) continue;
    if (item.to) return item.to;
    const firstChild = item.children?.find((child) =>
      matchAnyPermission(userPermissions, child.permissions)
    );
    if (firstChild?.to) return firstChild.to;
  }
  return '/unauthorized';
};

export const canAccessRoute = (userPermissions, route) => {
  const requiredPermissions = getRoutePermissions(route);
  if (requiredPermissions.length === 0) return true;
  return matchAnyPermission(userPermissions, requiredPermissions);
};
